import { render } from "./PhoneCalls.vue?vue&type=template&id=7bbcd418"
import script from "./PhoneCalls.vue?vue&type=script&lang=js"
export * from "./PhoneCalls.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__